// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  jsonHeader,
  postMethod,
  multipartJsonHeader,
}                     from '../fetchTools';

var options = {...defaultOptions, ...jsonHeader};
export const getSessionData = (name, params) => {
    console.log("sh get API ")
    console.log(name)
    if (params == null){
        params="";
    }
    const url = `${getLocationOrigin(1)}/${appConfig.sessions.data.API}${appConfig.sessions.data[name].path}/${params}`
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const postSessionData = (name, payload) => {
    console.log("sh post API ")
    console.log(name)
    console.log(payload)
    let url = `${getLocationOrigin(1)}/${appConfig.sessions.data.API}${appConfig.sessions.data[name].path}/`
    if (name == "update_objective" || name == "update_session_plan"){
        url = `${getLocationOrigin(1)}/${appConfig.sessions.data.API}${payload.id}/${appConfig.sessions.data[name].path}/`
    }
  var options = {...defaultOptions, ...postMethod, ...jsonHeader};
  options.method = 'post';
  options.body = JSON.stringify(payload);
  console.log(options)
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/session.js